import React, {useState, useEffect} from 'react';

import NurseryList from '../Component/NurseryList';

import * as Constant from '@app/Constant.js';


import axios from '@app/lib/axios';
import * as commonData from "@app/lib/common_data";

import NurseryFormTable from '../Component/NurseryFormTable';

import ContractView from '../Contract/List/View.js';
import ContractControlBtn from '../Component/ContractControlBtn.js';

const CONTRACT_TABLE_ID = "contractTable";

const Request = ({id}) => {
	const [data, setData] = useState(null);
    const [loadingData, setLoadingData] = useState(true);
    const [bizApp, setBizApp] = useState([]);
    const [serviceAppList, setServiceAppList] = useState(null);
    const [appAuthTypeList, setAppAuthTypeList] = useState(null);
    const [contractList, setContractList] = useState(null);

    useEffect(() => {
        if(!serviceAppList) {
            commonData.getServiceAppList(axios, (err, appList) => {
                if (!err) {
                    commonData.getAppAuthTypeList(axios, (err, typeList) => {
                        if (!err) {
                            setServiceAppList(appList);
                            setAppAuthTypeList(typeList);
                        } else {
                        }
                    });
                }
            });
        }
    }, []);

    useEffect(() => {
        if(!data) getData(id);
        if(!contractList) getContractList(id);
    }, [appAuthTypeList]);

    useEffect(() => {
    }, [data]);

    const getData = (id) => {
        setLoadingData(true);
        axios({
          method: "get",
          url: `${Constant.API_DOMAIN}/api/nursery/info/0/${id}`
        })
        .then(res => {
            setData(res.data.nursery);
            setLoadingData(false);
          })
        .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            setLoadingData(false);
        });
    }

    const getContractList = (id) => {
        axios({
          method: "get",
          url: `${Constant.API_DOMAIN}/api/contract/list/0/${id}`
        })
        .then(res => {
			const list = res.data && res.data.contract ? res.data.contract: [];
            // 기존 계약 승인 정보 보관
            list.forEach((c) => {
                if(c.app_auth) {
                    const auth = c.app_auth;
                    serviceAppList.forEach((a) => {
                        if(a.contractUseTas && bizApp[a.key]) {
                            if(auth[a.key] && auth[a.key].approval) {
                                auth[a.key].approval_org = auth[a.key].approval;
                                auth[a.key].authType_org = auth[a.key].authType;
                                auth[a.key].authTypeName_org = auth[a.key].authTypeName;
                            }
                        }
                    });
                    // 결합 상품 정보 설정
                    if(c.unionId_org) {
                        c.unionSelected = appAuthTypeList.all.find((at) => at.id == c.unionId);
                    }
                }
            });
			list.sort((a, b) => a.is555 == b.is555 ? (a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age) : (a.is555 ? 1 : -1));
            setBizApp(res.data.bizApp);
            setContractList(list);
          })
        .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
        });
    }

    const saveBtnHandler = () => {
        const nursery = window.getNurseryFormData();
        if(!nursery.code) {
            alert('원 코드가 발급 되지 않았습니다.');
            return ;
        }

        if(!nursery.name || !nursery.type || !nursery.sub_type || !nursery.ceo || !nursery.director || !nursery.sido || !nursery.sigungu || !nursery.addr
            || !nursery.tel
            ) {
            alert('입력이 누락된 항목이 있습니다.\n모든 항목에 정보를 입력하신 후 \n저장 버튼을 눌러주세요.');
            return;
        }
        nursery.status = 'active';
        
        setLoadingData(true);
        axios({
          method: "put",
          url: `${Constant.API_DOMAIN}/api/nursery/info`,
          data: {
            ...nursery
          }
        })
        .then(res => {
            document.location.href = './nursery?type=view&id='+nursery.id;
            setLoadingData(false);
          })
        .catch(error => {
            console.log(error);
            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            setLoadingData(false);
        });
    }


    const cancelHandler = () => {
        if(window.confirm('신규 원 등록을 취소하시겠습니까?')) {
            document.location.href = "./nursery";
        }
    }

    if(!data) {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                </div>
            </div>
        );
    }

    return (
		<div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                	<div className="row">
                    	<div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">원 관리 &gt; 원 등록요청 처리</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid dashboard-content pb-5">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-right col-12">
                            <button
                                className="btn btn-primary btn-rounded"
                                onClick={cancelHandler}
                            >
                                목록
                            </button>
                        </div>
                    </div>
                	<div className="row">
                        <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                            <NurseryFormTable nursery={data} />
                            <div className="mt-3">
                                <button
                                    className="btn btn-brand btn-rounded mr-2"
                                    onClick={saveBtnHandler}
                                    disabled={loadingData}
                                >
                                    저장
                                </button>
                                <button
                                    className="btn btn-default btn-rounded mr-2"
                                    onClick={cancelHandler}
                                    disabled={loadingData}
                                >
                                    취소
                                </button>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4>원 등록 요청</h4>
                                    <table className="table table-bordered">
                                        <colgroup>
                                            <col style={{width: '100px'}}/>
                                            <col />
                                        </colgroup>
                                        <tr>
                                            <th className="bg-primary">등록요청 지사</th>
                                            <td>{data && data.memo ? data.memo[0].branch_name : ''}</td>
                                        </tr>
                                        <tr>
                                            <th className="bg-primary">등록요청 일시</th>
                                            <td>{data ? data.create_date : ''}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                	</div>

                    <div className="row mt-5">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12" style={{overflow: 'auto'}}>
                            <ContractView.ContractViewBranch
                                tableId={CONTRACT_TABLE_ID}
                                bizApp={bizApp}
                                serviceAppList={serviceAppList}
                                appAuthTypeList={appAuthTypeList}
                                list={contractList}
                                nurseryName={data.name || ''}
                                isRecontractSeason={null}
                            />
                        </div>
                    </div>
                    <ContractControlBtn
                        branchId={0}
                        nurseryId={data.id}
                        nurseryName={data.name}
						directorName={data.director}
						address={data.address}
                        tableId={CONTRACT_TABLE_ID} 
                        list={contractList}
                        bizApp={bizApp}
                        serviceAppList={serviceAppList}
                        appAuthTypeList={appAuthTypeList}
                        isRecontractSeason={null}
                    />
                </div>
            </div>
        </div>
	);
}



export default Request;